import { get } from 'lodash';
import { connect } from 'react-redux';
import { DOCTOR_CARD_ROOT_KEY, SCHEDULING_ROOT_KEY } from '../../constants';
import { withSearchResults } from './withSearchResults';
import VirtualVisitSearchResults from './VirtualVisitSearchResults';

export const mapStateToProps = state => {
    const professional = state[DOCTOR_CARD_ROOT_KEY].professional;
    const bookingState = state[SCHEDULING_ROOT_KEY].bookingState;

    return {
        location: get(professional, 'providerLocation'),
        specialtyId: get(professional, 'specialtyId'),
        procedureId: get(bookingState, 'visit_reason'),
        carrierId: get(bookingState, 'insurance_carrier_id'),
        planId: get(bookingState, 'insurance_plan_id'),
    };
};

export default connect(mapStateToProps)(
    withSearchResults(VirtualVisitSearchResults)
);
